export default __webpack_public_path__ + "static/media/title_ja_pc.d280ceb3.png";